<!-- Navigation -->
<treo-vertical-navigation class="theme-dark"
                          [appearance]="'dense'"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="data.navigation.default"
                          [opened]="false"
                          *ngIf="isScreenSmall">

                          <div treoVerticalNavigationContentHeader>
                            <div class="logo">
                                <img src="assets/images/logo/logo.png">
                            </div>
                        </div>
</treo-vertical-navigation>



<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">



        <!-- Top bar -->
        <div class="top-bar cor-master">

            <div class="container">

                <button class="navigation-toggle-button" *ngIf="isScreenSmall && usuario.tipo == 'Administrador'" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>

                <!-- Logo -->
                <div class="h-14 w-14 mr-2 ml-4"
                     *ngIf="!isScreenSmall">
                    <img src="assets/images/logo/logo.png">
                </div>
                <div class="h-14 w-14 mr-2"
                     *ngIf="isScreenSmall">
                    <img src="assets/images/logo/logo.png">
                </div>
                <div class="flex flex-col" [matMenuTriggerFor]="_router.url.startsWith('/jogos') ? menuData : null" [ngStyle]="{ cursor: _router.url.startsWith('/jogos') ? 'pointer' : 'default' }">
                    <span class="font-semibold text-lg">{{titulo}}</span>
                 <span class="text-secondary text-sm">{{subtitulo}}</span>
                </div>



                <mat-menu #menuData="matMenu">
                            

                            <button *ngIf="usuario.aposta_aovivo == 'Sim' && configuracoes.aovivo == 'Sim'" (click)="jogosAoVivo()"
                                 mat-menu-item>
                                <div class="flex items-center">
                                    <mat-icon class="icon-size-20 mr-3 text-red-600 text-master font-semibold" [svgIcon]="'aovivo'"></mat-icon>
                                    <span>Ao vivo</span>
                                </div>
                            </button>

                            <button (click)="jogosHoje()" mat-menu-item>
                                <div class="flex items-center ">
                                    <mat-icon class="icon-size-20 mr-3" [svgIcon]="'calendar_today'"></mat-icon>
                                    <span>Hoje</span>
                                </div>
                            </button>

                            <button (click)="jogosAmanha()" mat-menu-item>
                                <div class="flex items-center">
                                    <mat-icon class="icon-size-20 mr-3" [svgIcon]="'calendar_today'"></mat-icon>
                                    <span>Amanhã</span>
                                </div>
                            </button>

                            <button (click)="jogosDepois()" mat-menu-item>
                                <div class="flex items-center">
                                    <mat-icon class="icon-size-20 mr-3" [svgIcon]="'calendar_today'"></mat-icon>
                                    <span>{{diaDepois()}}</span>
                                </div>
                            </button>

                            


                        </mat-menu>

                <!-- Navigation toggle button -->


                <!-- Spacer -->
                <div class="spacer"></div>

                <!-- Search -->


                <!-- User -->
                <user [user]="data.user"></user>


            </div>
        </div>

        <!-- Bottom bar -->
        <div class="bottom-bar"
             *ngIf="!isScreenSmall">

            <div class="container">

                <treo-horizontal-navigation class="ml-4" [name]="'mainNavigation'"
                                           [navigation]="data.navigation.horizontal"></treo-horizontal-navigation>
            </div>

        </div>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->






    <div *ngIf="isScreenSmall && usuario.tipo != 'Cliente'" class="footer justify-between">
        <div routerLink="/jogos" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:sports_soccer'"></mat-icon>
            </button>
        </div>

        <div *ngIf="usuario.tipo == 'Administrador' || usuario.tipo == 'Vendedor'" routerLink="/caixa" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:account_balance_wallet'"></mat-icon>
            </button>
        </div>

        <div *ngIf="usuario.tipo == 'Administrador' || usuario.tipo == 'Gerente'" routerLink="/financeiro" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:monetization_on'"></mat-icon>
            </button>
        </div>

        <div class="flex flex-col" routerLink="/bilhetes">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:receipt'"></mat-icon>
            </button>
            <!-- <span class="font-bold">Bilhetes</span> -->
        </div>
    </div>

</div>
